/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Directory_Submit_Enrich_PublishedInputs */

const en_directory_submit_enrich_published = /** @type {(inputs: Directory_Submit_Enrich_PublishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enriched listing published: '${i?.slug}'`)
};

const zh_directory_submit_enrich_published = /** @type {(inputs: Directory_Submit_Enrich_PublishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已生成并发布深度增强条目：'${i?.slug}'`)
};

/**
* | output |
* | --- |
* | "Enriched listing published: '{slug}'" |
*
* @param {Directory_Submit_Enrich_PublishedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_published = /** @type {((inputs: Directory_Submit_Enrich_PublishedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_PublishedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_published(inputs)
	return zh_directory_submit_enrich_published(inputs)
});
export { directory_submit_enrich_published as "directory.submit.enrich.published" }